import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';

export class DataJobForm extends CerFormAdapter {

  public override view(): CerFormView {
    return new CerFormView({
      mandatory: true,
      viewMetadata: {
        dataApiName: 'DataJob',
        name: 'data-udveksling-jobs', text: 'Datajobs',
        primaryKey: 'id',
        allowEdit: true, allowCreate: false, allowDelete: false,
        baseFields: ['id'],
        navigations: [
          { link: 'nav', foreignKey: { entity: 'DataJobLog', column: 'jobId', parentColumn: 'id' } },
        ]
      },
      fieldMetadata: [
        { name: 'name', text: 'Navn', required: true },
        { name: 'active', text: 'Aktiv', format: 'CheckBox', defaultValue: true },
        { name: 'sourceAddress', text: 'Adresse' },
        { name: 'processedAddress', text: 'Adresse (ok)' },
        { name: 'failedAddress', text: 'Adresse (fejl)' },
        { name: 'moveWeekDay', text: 'Flyt (ugedag)', format: 'Number0', visible: false },
        { name: 'created', text: 'Oprettet', format: 'DateTime', visible: false, width: '120px' },
        { name: 'modified', text: 'Ændret', format: 'DateTime', visible: false, width: '120px' }
      ]
    });
  }
}
